/**
 * 利用統計 API クライアントサービス
 */

import { getAuthInstance } from "../lib/firebase";
import { USAGE_STATS_API_BASE_URL } from "../constants/api";
import type { UsageStatsResponse } from "@ibs-ocr/shared";

/**
 * 認証ヘッダーを取得
 */
async function getAuthHeaders(): Promise<HeadersInit> {
  const auth = getAuthInstance();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("認証されていません");
  }

  const token = await user.getIdToken();

  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

/**
 * API エラーをハンドリング
 */
async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "不明なエラー" }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  return response.json();
}

/**
 * 指定月の利用統計を取得
 * @param year 年（例: 2026）
 * @param month 月（1-12）
 */
export async function fetchUsageStats(
  year: number,
  month: number
): Promise<UsageStatsResponse> {
  const headers = await getAuthHeaders();
  const response = await fetch(
    `${USAGE_STATS_API_BASE_URL}/stats?year=${year}&month=${month}`,
    { headers }
  );
  return handleResponse<UsageStatsResponse>(response);
}
